// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const current = "MoneyflowTrackerChart__current__TfJon";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const limit = "MoneyflowTrackerChart__limit__I2WFV";
export const limitDot = "MoneyflowTrackerChart__limitDot__cYr8a";
export const medium = "500";
export const moneyflowBar = "MoneyflowTrackerChart__moneyflowBar__SszYc";
export const moneyflowTrackerChart = "MoneyflowTrackerChart__moneyflowTrackerChart__x9vU1";
export const negativeValue = "MoneyflowTrackerChart__negativeValue__i1ohn";
export const outerLabel = "MoneyflowTrackerChart__outerLabel__DLRSg";
export const over = "MoneyflowTrackerChart__over__a75wz";
export const projection = "MoneyflowTrackerChart__projection__a9COq";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "MoneyflowTrackerChart__textCenter__Hfeg6";
export const tooltipContainer = "MoneyflowTrackerChart__tooltipContainer__tCLH3";
export const value = "MoneyflowTrackerChart__value__kAf19";
export const warning = "MoneyflowTrackerChart__warning__nQOXe";